var map = {
	"./nisarg/blog.png": "27f1",
	"./nisarg/checkout.png": "a3cb",
	"./nisarg/condition.png": "19b6",
	"./nisarg/desystems.png": "bac1",
	"./nisarg/edie.png": "36a6",
	"./nisarg/gaming.jpg": "352c",
	"./nisarg/guitar.jpg": "e66e",
	"./nisarg/image_uploader.png": "3eb6",
	"./nisarg/kunkka.png": "9e5d",
	"./nisarg/learning.jpg": "40ba",
	"./nisarg/mycs.png": "7c1e",
	"./nisarg/nokia.png": "5f2a",
	"./nisarg/site-desystems.png": "ce85",
	"./nisarg/unsplash.png": "aaf6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";